import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class RateStrategySerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    rsbaserates: { embedded: 'always' },
    rstypes: { embedded: 'always' },
    rssubtypes: { embedded: 'always' },
    rsstrategies: { embedded: 'always' },
    rscancellationpolicies: { embedded: 'always' },
    rspatterns: { embedded: 'always' },
  };
}
